// Validate input characters
export function InputValidatorDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      var VALID_PATTERN;

      switch (attrs.inputValidator) {
        case 'text':
          VALID_PATTERN =
            /^[a-zA-Z0-9\Á\á\É\é\Í\í\Ó\ó\Ú\ú\Ñ\ñ\_\=\+\-\*\'\"\?\¿\!\¡\.\:\,\#\$\&\/\(\)\ ]*$/;
          break;
        case 'phone':
          VALID_PATTERN = /^[\d- ]+$/; // numbers and - and spaces
          break;
        case 'username':
          VALID_PATTERN = /^[a-z\d_]+$/; // ^[-\w]+$
          break;
        case 'credit_card_number':
          VALID_PATTERN = /^[\d- ]+$/; // numbers and - and spaces
          break;
        default:
          VALID_PATTERN = attrs.inputValidator;
          break;
      }

      if (attrs.inputValidator === 'text') {
        return true; // Problems with German characters
      }

      ngModel.$validators.pattern = function (inputValue) {
        var status = true;
        if (inputValue) {
          status = status && VALID_PATTERN.test(inputValue);
        }

        return status;
      };
    },
  };
}
